import {
  BottomNavigation,
  BottomNavigationAction,
  Box,
  Paper,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AuthContext from "../../context/AuthContext";

export default function AuditLogHeader({ value = 0 }) {
  const { permission, pages, pagesName } = useContext(AuthContext);
  const [valueData, setValue] = React.useState(value);
  return (
    <>
      <Paper elevation={0}>
        {/* <Box sx={{ paddingLeft:'1rem',paddingRight:'1rem' ,maxWidth:'95vw'   }}> */}
        <BottomNavigation
          sx={{
            overflow: "auto",
          }}
          className=" flex-wrap justify-content-start "
          showLabels
          value={valueData}
          onChange={(event, newValue) => {
            setValue(newValue);
          }}
        >
          <BottomNavigationAction
            sx={{
              flex: "0 0 auto",
              padding: "0px",
              height:'0px !important',
              color: "#333333",
              fontSize: "14px !important",
              backgroundColor:'#f3f3f3',
              padding:'18px 30px !important',
              borderRadius:'40px',
              "& .MuiBottomNavigationAction-label": {
                whiteSpace: "nowrap !important",
                fontWeight: "500",
                fontSize: "14px !important",
              },
              ".Mui-selected&": {
                color: "#fff",
                fontSize: "14px !important",
                backgroundColor:'rgba(191, 29, 45, 0.8)',
                padding:'18px 30px !important',
                borderRadius:'40px'
              },
            }}
            label="Audit Log"
            component={Link}
            to={"/firehouse/audit-log"}
            className={"mx-2 p-0 "}
          />
          <BottomNavigationAction
            sx={{
              flex: "0 0 auto",
              padding: "0px",
              height:'0px !important',
              color: "#333333",
              fontSize: "14px !important",
              backgroundColor:'#f3f3f3',
              padding:'18px 30px !important',
              borderRadius:'40px',
              "& .MuiBottomNavigationAction-label": {
                whiteSpace: "nowrap !important",
                fontWeight: "500",
                fontSize: "14px !important",
              },
              ".Mui-selected&": {
                color: "#fff",
                fontSize: "14px !important",
                backgroundColor:'rgba(191, 29, 45, 0.8)',
                padding:'18px 30px !important',
                borderRadius:'40px'
              },
            }}
            label="Audit Log Setting"
            component={Link}
            to={"/firehouse/audit-log-setting"}
            className={"p-0 "}
          />
        </BottomNavigation>

        {/* </Box> */}
      </Paper>
    </>
  );
}
